"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var WhatsOnTVTabType;
(function (WhatsOnTVTabType) {
    WhatsOnTVTabType["Recent"] = "Recent";
    WhatsOnTVTabType["Upcoming"] = "Upcoming";
})(WhatsOnTVTabType = exports.WhatsOnTVTabType || (exports.WhatsOnTVTabType = {}));
//# sourceMappingURL=WhatsOnTVTabType.js.map